import moment from 'moment';
import axios from 'axios';

export function formatAmount(amount) {
  if (typeof amount !== 'undefined') {
    if (typeof amount !== 'string') {
      amount = amount.toString();
    }
  } else {
    amount = '0.00'; 
  }

  const cleanedAmount = amount.replace(/,/g, '');

  if (isNaN(cleanedAmount) || cleanedAmount == "") {
    return '0.00'; 
  } 

  let formattedAmount = parseFloat(cleanedAmount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  if (formattedAmount.includes('-')) {
    formattedAmount = `(${formattedAmount.replace('-', '')})`;
  }

  return formattedAmount;
}

export function formatFourDecimal(amount) {
  if (typeof amount !== 'undefined') {
    if (typeof amount !== 'string') {
      amount = amount.toString();
    }
  } else {
    amount = '0.00'; 
  }

  const cleanedAmount = amount.replace(/,/g, '');

  if (isNaN(cleanedAmount) || cleanedAmount == "") {
    return '0.00'; 
  } 

  let formattedAmount = parseFloat(cleanedAmount).toLocaleString(undefined, { minimumFractionDigits: 4, maximumFractionDigits: 4 });

  if (formattedAmount.includes('-')) {
    formattedAmount = `(${formattedAmount.replace('-', '')})`;
  }

  return formattedAmount;
}

// import moment

export function formatDate(date, format = 'YYYY-MM-DD') {
  return moment(date).format(format);
}

export function formatTime(time, format = 'HH:mm:ss') {
  return moment(time).format(format);
}

export function formatDateTime(datetime, format = 'YYYY-MM-DD HH:mm') {
  return moment(datetime).format(format);
}

export function formatAsMoney(params) {
  if (params && params.value != null) {
    let value = params.value;
    if (typeof value === 'string') {
      value = parseFloat(value.replace(/,/g, ''));
    }
    if (!isNaN(value)) {
      return value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    }
  }
  return '0.00';
}

export function formatFourAsMoney(params) {
  if (params && params.value != null) {
    let value = params.value;
    if (typeof value === 'string') {
      value = parseFloat(value.replace(/,/g, ''));
    }
    if (!isNaN(value)) {
      return value.toFixed(4).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    }
  }
  return '0.00';
}

export async function checkAvailability(data) {
  try {
    const params = {
      t: data.t,
      c: data.c,
      v: data.v,
      ci: data.ci,
      civ: data.civ,
    };
    if (data.c2 !== undefined && data.v2 !== undefined) {
      params.c2 = data.c2;
      params.v2 = data.v2;
    }
    if (data.c3 !== undefined && data.v3 !== undefined) {
      params.c3 = data.c3;
      params.v3 = data.v3;
    }
    if (data.c4 !== undefined && data.v4 !== undefined) {
      params.c4 = data.c4;
      params.v4 = data.v4;
    }
    const response = await axios.get(`${process.env.VUE_APP_AUTHDOMAIN}/api/v1/check-exists`, { 
      params
    });
    return response.data !== 0;
  } catch (error) {
    throw new Error("Error checking value availability.");
  }
}